/**
 * Politica de Cookies e Privacidade da Empiria, versao de 22 de julho de 2026.
 * Transcricao integral do PDF aprovado -- nao reescrever nem resumir.
 * Duas observacoes sobre o documento, que sao dele e nao da transcricao:
 *   - a numeracao reinicia na secao 5 ("DA POLITICA DE PRIVACIDADE"): dali em
 *     diante o documento volta a contar de 1, e os itens foram mantidos assim;
 *   - o titulo da secao 12 vem com um marcador de nota de rodape colado
 *     ("DUVIDAS1"), removido aqui por ser artefato de diagramacao.
 * CORRECAO APLICADA: o PDF cita o Encarregado duas vezes como
 * dpo@empiriapp.com.br (itens F e 9) e uma vez como empiriapp@gmail.com
 * (secao 12). Como e o mesmo papel, o endereco publicado e o do dominio
 * proprio nas tres ocorrencias. Registrado em
 * PENDENCIAS_COM_O_CLIENTE.txt, na raiz do projeto.
 */
const cookiesEPrivacidade = [
    {
        tipo: "texto",
        texto:
            "Ao visitar a Plataforma da Empiria, alguns cookies poderão ser utilizados. Essa Política de Cookies e Privacidade esclarece detalhes sobre a utilização desses cookies e da privacidade, em especial, quais as categorias de cookies e respectivas finalidades. Por isso, leia com atenção as informações abaixo. Esta Política de Cookies e Privacidade integra os Termos de Uso da Empiria. Você deve ler de forma atenta e cuidadosa as condições a seguir, pois elas contêm informações importantes.",
    },
    {
        tipo: "texto",
        texto:
            "Se, em razão da utilização de cookies, esta Plataforma realizar o tratamento de dados pessoais, será aplicada a seção 5 da Política de Privacidade.",
    },
    {
        tipo: "texto",
        texto:
            "Esta Política pode ser modificada a qualquer momento, por isso é importante que você constantemente revise os seus termos. Quando alterações substanciais forem realizadas a esta Política, você será informado por e-mail caso seja um Usuário cadastrado na Plataforma da Empiria. Esta Política e suas respectivas atualizações prevalecem sobre quaisquer propostas, contratos, entendimentos anteriores e acordos, verbais ou escritos, que possam existir entre você e a empresa Empiria, especialmente versando sobre cookies e privacidade ou dados pessoais.",
    },
    {
        tipo: "secao",
        texto:
            "VISÃO GERAL",
    },
    {
        tipo: "item",
        id: "A.",
        texto:
            "Esta Política de cookies estabelece (a) quais cookies são utilizados (b) para quais finalidades os cookies são utilizados e (c) como os Usuários podem gerenciar suas escolhas de configuração de cookies em seus navegadores. Esta Política de cookies se aplica ao uso ou acesso à Plataforma mediante o site www.empiriapp.com.br e seus subdomínios, bem como mediante outros sites ou interfaces nos quais a empresa Empiria disponibilize seus recursos.",
    },
    {
        tipo: "item",
        id: "B.",
        texto:
            "Para facilitar a leitura desta Política, oferecemos um Glossário, que relaciona o significado das expressões iniciadas por letras maiúsculas nos Termos da Empiria, bem como nesta ou em outras Políticas da Empiria. Além disso, é importante você compreender o significado específico da expressão a seguir, utilizada no contexto desta Política e grafada nos Termos, nesta Política ou em outras Políticas da Empiria sem iniciais maiúsculas:",
    },
    {
        tipo: "item",
        id: "C.",
        texto:
            "\"Cookies\", no singular ou no plural, são pequenos arquivos (geralmente contendo texto) que são armazenados em um determinado equipamento de acesso para registro de preferências e outras informações. A Plataforma pode utilizar Cookies definidos por nós, chamados de Cookies primários, e/ou a Plataforma pode utilizar Cookies de terceiros, que são cookies de um domínio diferente do domínio da Plataforma. Os Cookies de terceiros nos permitem analisar como a Plataforma está sendo utilizada, medir o número de visitantes e exibir publicidade.",
    },
    {
        tipo: "secao",
        texto:
            "1. QUE TIPOS DE COOKIES UTILIZAMOS?",
    },
    {
        tipo: "item",
        id: "1.1.",
        texto:
            "Existem dois tipos de Cookies que podem ser utilizados pela Empiria considerando a sua duração:",
    },
    {
        tipo: "item",
        id: "1.1.1.",
        texto:
            "Cookies Permanentes: São cookies que ficam armazenados pelo navegador nos equipamentos de acesso do Usuário, por um determinado período de tempo, e que são utilizados sempre que você faz uma nova visita a um dos nossos sites. São utilizados, geralmente, para direcionar a navegação aos seus interesses, permitindo-nos prestar um serviço mais personalizado.",
    },
    {
        tipo: "item",
        id: "1.1.2.",
        texto:
            "Cookies de Sessão: São cookies temporários que permanecem no arquivo de cookies do seu navegador até que você encerre a sessão de navegação. A informação armazenada nesses Cookies geralmente é utilizada para armazenar suas preferências temporariamente.",
    },
    {
        tipo: "secao",
        texto:
            "2. CATEGORIAS DE COOKIES",
    },
    {
        tipo: "item",
        id: "2.1.",
        texto:
            "Existem duas categorias de Cookies que podem ser utilizados pela Empiria:",
    },
    {
        tipo: "item",
        id: "2.1.1.",
        texto:
            "Cookies essenciais: esses Cookies são necessários para o funcionamento do site e não podem ser desativados em nossos sistemas. Eles geralmente são definidos apenas em resposta a ações feitas por você que equivalem a uma solicitação de serviços, como definir suas preferências de privacidade, fazer login ou preencher formulários. Você pode configurar seu navegador para bloquear ou alertá-lo sobre esses cookies, mas isso pode afetar a disponibilidade e a funcionalidade de algumas partes do site. Abaixo estão as subcategorias de Cookies essenciais:",
    },
    {
        tipo: "item",
        id: "2.1.1.1.",
        texto:
            "Preferenciais: Usamos esses cookies para permitir que a Plataforma lembre das informações que mudam a forma como o site se comporta ou é exibido (por exemplo, idioma escolhido, cesta de compras).",
    },
    {
        tipo: "item",
        id: "2.1.1.2.",
        texto:
            "Segurança: Usamos esses Cookies para permitir a verificação da identidade do Usuário, para evitar a utilização fraudulenta das credenciais de login e proteger os dados do Usuário de uso não autorizado por terceiros.",
    },
    {
        tipo: "item",
        id: "2.1.1.3.",
        texto:
            "Analíticos: Para oferecer a você a melhor experiência de navegação possível, é importante entendermos como os visitantes usam nosso site. Os dados coletados por esses Cookies nos ajudam a conseguir isso e são agregados para um resultado estatístico.",
    },
    {
        tipo: "item",
        id: "2.1.1.4.",
        texto:
            "Performance: Permite que, por meio do armazenamento de arquivos nos dispositivos dos visitantes dos websites, seja registrado os cliques em links, anúncios e transações comerciais, como vendas e leads, para identificar uma transação efetivada por um Conviva por meio de um link recebido de Anfitrião, permitindo assim o comissionamento da transação concretizada.",
    },
    {
        tipo: "item",
        id: "2.2.",
        texto:
            "Cookies não essenciais: Estes Cookies não são necessários para o funcionamento do site e podem ser gerenciados pelo Usuário. Caso estes Cookies não sejam ativados pelo Usuário, a Plataforma ficará menos funcional, mas o uso da Plataforma pelo Usuário não será impedido. Abaixo a subcategoria para os Cookies não essenciais:",
    },
    {
        tipo: "item",
        id: "2.2.1.",
        texto:
            "Publicidade: Estes cookies são usados para ajudar a garantir que você esteja recebendo as mensagens de marketing mais relevantes. Por exemplo, esses Cookies são usados para ajudar a exibir anúncios com base em seus interesses, garantir que esses anúncios sejam exibidos corretamente e evitar que o mesmo anúncio seja exibido repetidamente.",
    },
    {
        tipo: "secao",
        texto:
            "3. COMO GERENCIAR OS COOKIES?",
    },
    {
        tipo: "item",
        id: "3.1.",
        texto:
            "Cookies essenciais: Estes cookies são necessários para o funcionamento da Plataforma e você não pode gerenciá-los. Mas, após o uso da Plataforma, você pode eliminar os Cookies necessários seguindo as instruções do navegador utilizado.",
    },
    {
        tipo: "item",
        id: "3.2.",
        texto:
            "Cookies não essenciais: Estes Cookies podem ser gerenciados por você através das configurações disponíveis no navegador utilizado.",
    },
    {
        tipo: "secao",
        texto:
            "4. COOKIES EM SITES DE TERCEIROS",
    },
    {
        tipo: "item",
        id: "4.1.",
        texto:
            "Ao utilizar a Plataforma, você poderá ser redirecionado para sites de terceiros. Esses sites poderão utilizar seus próprios Cookies. A Empiria não tem controle sobre o uso destes Cookies.",
    },
    {
        tipo: "item",
        id: "4.2.",
        texto:
            "Ressalta-se que o terceiro pode se tratar de Anfitrião da Plataforma. Nesse sentido, o Anfitrião é integralmente responsável por cumprir as leis aplicáveis de proteção de dados pessoais, dando transparência aos seus usuários finais sobre a utilização de cookies em seus sites.",
    },
    {
        tipo: "secao",
        texto:
            "5. DA POLÍTICA DE PRIVACIDADE",
    },
    {
        tipo: "item",
        id: "A.",
        texto:
            "Esta Política de Privacidade estabelece as regras sobre: (a) como e para quais finalidades seus dados pessoais podem ser tratados pela Empiria, (b) com quem esses dados podem ser compartilhados, e (c) como os Usuários podem gerenciar seus dados pessoais. Ela se aplica ao uso ou acesso à Plataforma ou demais serviços ofertados pela empresa Empiria mediante quaisquer de seus sites e seus subdomínios, bem como mediante outros sites, interfaces ou aplicativos nos quais a empresa Empiria disponibilize seus recursos, inclusive seus aplicativos de celular, tablet ou de outros dispositivos eletrônicos.",
    },
    {
        tipo: "item",
        id: "B.",
        texto:
            "\"Dados pessoais\", no singular ou no plural, significa qualquer informação que identifique o Usuário ou que torne possível a sua identificação.",
    },
    {
        tipo: "item",
        id: "C.",
        texto:
            "\"Tratamento\", assim como o verbo \"tratar\", significa qualquer operação realizada com dados pessoais, como as que se referem a coleta, produção, recepção, classificação, utilização, acesso, reprodução, transmissão, distribuição, processamento, arquivamento, armazenamento, eliminação, avaliação, controle, modificação, comunicação, transferência, difusão ou extração.",
    },
    {
        tipo: "item",
        id: "D.",
        texto:
            "\"Dados de conta do Usuário\": significa dados relativos ao Usuário que são necessários à prestação dos serviços ofertados pela empresa Empiria.",
    },
    {
        tipo: "item",
        id: "E.",
        texto:
            "\"Dados de conta do Anfitrião\": significa dados pessoais que são tratados pela Empiria em nome do Anfitrião, quando os dados pessoais são transferidos ao Anfitrião e/ou extraídos, coletados e/ou gerados diretamente pelo Anfitrião. As regras para o tratamento de dados pessoais entre Empiria e Anfitrião estão estabelecidas no Termo de Tratamento de Dados Pessoais.",
    },
    {
        tipo: "item",
        id: "F.",
        texto:
            "Encarregado pelo Tratamento de Dados Pessoais (Encarregado/DPO) Em cumprimento ao artigo 41 da Lei Geral de Proteção de Dados (LGPD), a Empiria mantém um Encarregado pelo Tratamento de Dados Pessoais (Data Protection Officer), responsável por receber comunicações do titular, prestar esclarecimentos e adotar providências, bem como atuar como canal de comunicação com a Autoridade Nacional de Proteção de Dados (ANPD). O Encarregado pode ser contatado pelo e-mail dpo@empiriapp.com.br.",
    },
    {
        tipo: "secao",
        texto:
            "1. DADOS PESSOAIS TRATADOS PELA EMPRESA EMPIRIA",
    },
    {
        tipo: "item",
        id: "1.1.",
        texto:
            "Os dados pessoais tratados pela empresa Empiria (\"Dados de Conta do Conviva\" e \"Dados de conta do Anfitrião\") podem variar, de acordo com suas práticas de tratamento de dados pessoais, bem como a depender do tipo de interação do Usuário com a Plataforma ou com a empresa Empiria.",
    },
    {
        tipo: "item",
        id: "1.2.",
        texto:
            "Esses dados pessoais podem ser coletados diretamente do Usuário, obtidos através de terceiros ou coletados automaticamente.",
    },
    {
        tipo: "item",
        id: "1.3.",
        texto:
            "Os dados pessoais podem envolver, exemplificativamente: (a) informações cadastrais, como e-mail, nome completo, endereço, telefone, celular, documentos de identificação, foto de perfil e passaporte; e (b) informações bancárias, como nome da instituição financeira na qual o Usuário possui conta bancária, número da conta, tipo de conta, agência, os seis primeiros e os últimos quatro dígitos do cartão de crédito, incluindo nome do titular.",
    },
    {
        tipo: "item",
        id: "1.4.",
        texto:
            "Abaixo estão listados os dados pessoais que são coletados pela empresa Empiria, apresentados em categorias e formas de coleta distintas para facilitar a sua compreensão.",
    },
    {
        tipo: "item",
        id: "1.4.1.",
        texto:
            "Dados Pessoais coletados diretamente do Usuário. A empresa Empiria pode coletar dados pessoais diretamente de você, quando você, por exemplo, cria uma conta, inicia um processo de compra diretamente via checkout e/ou interage com a empresa Empiria por qualquer meio, inclusive por nosso chatbot.",
    },
    {
        tipo: "item",
        id: "1.4.2.",
        texto:
            "Interação \"offline\". A empresa Empiria pode coletar dados pessoais quando você interage com ela por outros meios que não seja o acesso à Plataforma, como, por exemplo, seus dados cadastrais ou sua imagem quando você participa de um evento organizado pela empresa Empiria ou por um terceiro cuja atividade esteja contratualmente vinculada à empresa Empiria.",
    },
    {
        tipo: "item",
        id: "1.4.3.",
        texto:
            "Campos opcionais. A Plataforma disponibiliza certos campos de preenchimento opcional. Esses campos estão destacados como opcionais e têm a finalidade de melhorar a personalização do conteúdo disponibilizado ao Usuário.",
    },
    {
        tipo: "item",
        id: "1.4.4.",
        texto:
            "Dados públicos. A empresa Empiria considera alguns dados pessoais como públicos, porque podem ser vistos por qualquer pessoa, dentro e fora da Plataforma, inclusive se essa pessoa não tiver uma conta na Plataforma. São considerados dados públicos as informações que você inserir nos campos destacados com o aviso \"dados públicos\". Você, outras pessoas que usam a Plataforma e a própria empresa Empiria podem fornecer acesso ou enviar dados públicos para qualquer pessoa dentro e fora da Plataforma.",
    },
    {
        tipo: "item",
        id: "1.4.5.",
        texto:
            "Dados pessoais obtidos de terceiros. A empresa Empiria pode ter acesso a determinados dados pessoais por intermédio de terceiros, sejam eles informações cadastrais ou bancárias. Isso acontece, por exemplo, quando, em razão de cumprimento de obrigação legal ou regulatória, a empresa Empiria precisa consultar bancos de dados mantidos por terceiros que viabilizem a análise de restrições creditícias, análises antifraude e demais análises de gestão de risco integrados à Plataforma.",
    },
    {
        tipo: "item",
        id: "1.4.6.",
        texto:
            "Dados Pessoais coletados automaticamente ao acessar a Plataforma. Dados pessoais são coletados automaticamente quando você acessa a Plataforma, mesmo se você não tiver conta na Plataforma. Essas informações podem incluir as exemplificadas abaixo.",
    },
    {
        tipo: "item",
        id: "1.4.6.1.",
        texto:
            "Informações de transação de pagamento: instrumento de pagamento usado; data e hora da transação; valor do pagamento; data de vencimento do instrumento de pagamento; código postal de cobrança; informações do IBAN, endereço e outros detalhes relacionados à transação de pagamento.",
    },
    {
        tipo: "item",
        id: "1.4.6.2.",
        texto:
            "Informações de acesso ou uso: páginas e conteúdo que você visualiza; buscas por anúncios; frequência de utilização da Plataforma; informação sobre o navegador; dados de conexão; histórico de compras e histórico de navegação.",
    },
    {
        tipo: "item",
        id: "1.4.6.3.",
        texto:
            "Dados de log e informações do dispositivo: detalhes sobre como você acessou e usou a Plataforma; endereço de IP; datas e horários de acesso; informações de hardware e software; identificadores exclusivos; dados de falha; dados de cookies, pixel e tecnologias semelhantes.",
    },
    {
        tipo: "item",
        id: "1.4.6.4.",
        texto:
            "Participação dos Encontros de Anfitriões. Quando você adquire ou é selecionado a um encontro, usa ou acessa outros conteúdos de Anfitriões, coletamos dados pessoais relativos à sua participação no Encontro.",
    },
    {
        tipo: "item",
        id: "1.4.6.5.",
        texto:
            "Informações de Pagamento. Nós utilizamos gateways de pagamentos de terceiros para processar os pagamentos realizados pela Plataforma. Para pagamentos processados pelos gateways de pagamento nativos da empresa Empiria, terceiros nos fornecem informações relacionadas ao status de pagamento da sua conta, sendo necessário que você vincule a sua conta de pagamento à Plataforma para receber os seus pagamentos.",
    },
    {
        tipo: "secao",
        texto:
            "2. QUAIS AS FINALIDADES DE TRATAMENTO DOS DADOS PESSOAIS",
    },
    {
        tipo: "item",
        id: "2.1.",
        texto:
            "Finalidades do Tratamento dos Dados Pessoais do Usuário. A empresa Empiria pode utilizar os dados pessoais para as seguintes finalidades:",
    },
    {
        tipo: "item",
        id: "2.1.1.",
        texto:
            "Fornecer e desenvolver a Plataforma: vincular sua conta com redes sociais terceiras; personalizar a Plataforma; realizar análises e estudos de comportamento; melhorar a Plataforma; arquivar histórico de compra; atualizar cadastro; enviar mensagens e notificações; realizar suporte; permitir publicação de conteúdo; treinar sistemas de Inteligência Artificial construídos pela Empiria ou por terceiros, utilizando- se apenas e unicamente dados cadastrais dos Usuários.",
    },
    {
        tipo: "texto",
        texto:
            "A base legal para o treinamento de sistemas de Inteligência Artificial com dados cadastrais é o legítimo interesse da Empiria (art. 7º, IX, e art. 10 da LGPD), sempre precedido de avaliação de necessidade e proporcionalidade e de mecanismos de anonimização ou pseudonimização sempre que tecnicamente possível. O Usuário pode se opor a esse tratamento específico a qualquer momento, nos termos do item 9.1.9 desta Política, sem prejuízo do uso regular da Plataforma.",
    },
    {
        tipo: "item",
        id: "2.1.2.",
        texto:
            "Fornecer e otimizar as atividades de publicidade e marketing: cadastro em eventos; envio de newsletter; comunicações via e-mail, SMS ou telefone; materiais educativos; campanhas de mídia; análise de comportamento de navegação.",
    },
    {
        tipo: "item",
        id: "2.1.3.",
        texto:
            "Viabilizar os Serviços de pagamento: comunicações ligadas ao pagamento; arranjo com bandeiras de cartão; emissão de moeda eletrônica; credenciamento e emissão de instrumento de pagamento; gestão de conta de pagamento; conversão de moeda; remessa de fundos.",
    },
    {
        tipo: "item",
        id: "2.1.4.",
        texto:
            "Manter um ambiente seguro: autenticação; verificação de autenticidade de dados e documentos; prevenção a fraudes, incidentes de segurança e abusos; segurança dos ambientes físicos; verificação de cadastro e de conteúdo.",
    },
    {
        tipo: "item",
        id: "2.1.5.",
        texto:
            "Finalidades do Tratamento dos Dados Pessoais de Visitante: campanhas de mídia; comunicações de marketing; análise de comportamento de navegação; cadastro em eventos; newsletter.",
    },
    {
        tipo: "secao",
        texto:
            "3. BASES LEGAIS DE TRATAMENTO",
    },
    {
        tipo: "item",
        id: "3.1.",
        texto:
            "Bases Legais. O tratamento de dados pessoais realizado pela empresa Empiria é sempre fundamentado em uma base legal prevista nas legislações aplicáveis. As bases legais utilizadas pela empresa Empiria podem variar a depender do contexto de tratamento, e incluem as seguintes:",
    },
    {
        tipo: "item",
        id: "3.1.1.",
        texto:
            "Consentimento. Quando o Usuário manifestamente aceita o tratamento de dados pessoais, como, por exemplo, quando concorda com o recebimento de comunicados publicitários ou pesquisas. Esse consentimento pode ser revogado a qualquer momento pelo Usuário.",
    },
    {
        tipo: "item",
        id: "3.1.2.",
        texto:
            "Cumprimento de obrigação legal ou regulatória. Quando a empresa Empiria é obrigada a realizar o tratamento de dados pessoais em razão de determinação legal ou regulatória, como, por exemplo, armazenar registros de acesso para fins de conformidade com legislações sobre prevenção à lavagem de dinheiro.",
    },
    {
        tipo: "item",
        id: "3.1.3.",
        texto:
            "Execução do Contrato ou procedimentos relacionados ao Contrato. Quando o tratamento de dados pessoais é necessário para a execução de um contrato firmado entre a empresa Empiria e o Usuário, ou quando necessário para procedimentos preliminares ao contrato.",
    },
    {
        tipo: "item",
        id: "3.1.4.",
        texto:
            "Exercício regular de direitos em processo judicial, administrativo ou arbitral.",
    },
    {
        tipo: "item",
        id: "3.1.5.",
        texto:
            "Legítimo interesse. Quando a empresa Empiria decide prosseguir com o tratamento dos dados pessoais após análise criteriosa envolvendo a avaliação da finalidade e necessidade do tratamento ao Usuário e da expectativa do Usuário quanto ao tratamento dos Dados pessoais. Nesse caso, a empresa Empiria sempre viabiliza ao Usuário a opção de cancelar o recebimento dessas comunicações ou de se opor ao tratamento.",
    },
    {
        tipo: "secao",
        texto:
            "4. DADOS PESSOAIS TRATADOS PELA EMPRESA EMPIRIA EM NOME DE TERCEIROS",
    },
    {
        tipo: "item",
        id: "4.1.",
        texto:
            "Tratamento de Dados Pessoais a Pedido de Terceiros. Existem dados pessoais que são tratados pela empresa Empiria a pedido de terceiros, seguindo regras formalizadas por meio de contratos escritos. Por exemplo, o Anfitrião pode solicitar, através da Plataforma, dados pessoais adicionais ao Conviva (\"Dados do Anfitrião\").",
    },
    {
        tipo: "item",
        id: "4.2.",
        texto:
            "Tratamento de Dados Pessoais relativos a Serviços de pagamento. A empresa Empiria também pode tratar determinados dados pessoais em nome de terceiros quando você optar por utilizar os Serviços de pagamento.",
    },
    {
        tipo: "item",
        id: "4.3.",
        texto:
            "Responsabilidade pelo Tratamento de Dados Pessoais por Terceiros. Os terceiros referidos nos itens anteriores também são agentes de tratamento responsáveis pelos dados pessoais no contexto do oferecimento de seus produtos e serviços.",
    },
    {
        tipo: "item",
        id: "4.4.",
        texto:
            "Em especial, o Usuário que optar pelo Serviço de pagamento possui um vínculo contratual com esses terceiros e, portanto, está vinculado também aos termos de uso e às políticas de privacidade aplicáveis a esses terceiros.",
    },
    {
        tipo: "secao",
        texto:
            "5. PERÍODO DE RETENÇÃO DOS DADOS PESSOAIS",
    },
    {
        tipo: "item",
        id: "5.1.",
        texto:
            "Período de Tratamento. Os dados pessoais são tratados pela empresa Empiria até que pelo menos uma das hipóteses abaixo descritas seja atingida: alcance da finalidade do tratamento; os dados deixarem de ser necessários ou pertinentes; término do Contrato com o Usuário; exercício do direito de revogação do consentimento; eventual penalização aplicada pela autoridade competente.",
    },
    {
        tipo: "item",
        id: "5.2.",
        texto:
            "Conservação dos Dados Pessoais. Em determinadas situações, a empresa Empiria pode conservar residualmente os dados pessoais mesmo após o término do tratamento, em virtude de cumprimento de obrigação legal ou regulatória, ou finalidade legítima. Nesses casos, os dados serão armazenados em local seguro com acesso restrito e pelo tempo necessário.",
    },
    {
        tipo: "item",
        id: "5.3.",
        texto:
            "Os períodos de conservação dos dados pessoais são diferentes e dependem do tipo de informação e dos objetivos para os quais utilizamos a informação. Para mais detalhes sobre o período de retenção de uma determinada categoria de dados pessoais, por favor entre em contato pelo e-mail dpo@empiriapp.com.br.",
    },
    {
        tipo: "texto",
        texto:
            "A Empiria compromete-se a responder às solicitações relacionadas a esta Política em até 15 (quinze) dias corridos, contados do recebimento da solicitação, prazo que poderá ser prorrogado uma única vez por igual período, mediante justificativa comunicada ao titular.",
    },
    {
        tipo: "secao",
        texto:
            "6. COMPARTILHAMENTO DOS DADOS PESSOAIS",
    },
    {
        tipo: "item",
        id: "6.1.",
        texto:
            "A empresa Empiria apenas compartilha dados pessoais com terceiros nas circunstâncias descritas abaixo. Esses terceiros celebram contrato por escrito com a empresa Empiria e estão cientes das suas responsabilidades em cada etapa do tratamento. A empresa Empiria não vende dados pessoais.",
    },
    {
        tipo: "item",
        id: "6.1.1.",
        texto:
            "Consentimento do Usuário.",
    },
    {
        tipo: "item",
        id: "6.1.2.",
        texto:
            "Cumprimento da lei, prevenção de danos e segurança, o que pode envolver decisões automatizadas de análise de risco.",
    },
    {
        tipo: "item",
        id: "6.1.2.1.",
        texto:
            "Revisão de decisões automatizadas Nos termos do artigo 20 da LGPD, o titular dos dados tem o direito de solicitar a revisão, por pessoa natural, de decisões tomadas unicamente com base em tratamento automatizado de dados pessoais que afetem seus interesses, incluindo decisões destinadas a analisar aspectos de risco de fraude, bloqueio de pagamentos ou suspensão de conta previstas na Política Geral de Compra e Pagamento. A solicitação de revisão pode ser feita pelo mesmo canal indicado no item 5.3 desta Política.",
    },
    {
        tipo: "item",
        id: "6.1.3.",
        texto:
            "Serviços de pagamento — os dados pessoais, incluindo o número do cartão, serão compartilhados com a bandeira do cartão de crédito e com a instituição de pagamento parceira da empresa Empiria.",
    },
    {
        tipo: "item",
        id: "6.1.4.",
        texto:
            "Entre Sociedades do seu Grupo Econômico, para viabilizar os Serviços, gerar eficiências administrativas e facilitar a utilização de serviços distintos pelo mesmo Usuário, inclusive em cenários de venda, aquisição, fusão ou consolidação de negócios.",
    },
    {
        tipo: "item",
        id: "6.1.5.",
        texto:
            "Prestadores de Serviços envolvidos em assessoria financeira, contábil, jurídica, backup de dados, computação em nuvem ou estudos analíticos.",
    },
    {
        tipo: "item",
        id: "6.1.6.",
        texto:
            "Compartilhamento de Informações entre Usuários, quando você participa de um Encontro do Anfitrião.",
    },
    {
        tipo: "item",
        id: "6.1.6.1.",
        texto:
            "Funcionalidade de Acompanhamento de Anfitriões Quando o Conviva opta por Acompanhar um Anfitrião, nos termos do item 1.12 dos Termos Gerais de Uso, a Empiria trata o dado dessa relação de acompanhamento para a finalidade específica de enviar ao Conviva notificações sobre novos Encontros, valores e horários de agenda daquele Anfitrião. O Anfitrião não recebe, em razão dessa funcionalidade, qualquer dado de identificação ou de contato dos Convivas que o seguem, podendo ter acesso apenas ao número agregado de Convivas que o acompanham, quando essa informação for disponibilizada pela Plataforma. A base legal para esse tratamento é a execução do contrato e o legítimo interesse do Usuário na funcionalidade que ele mesmo ativou, podendo o Conviva desativar o acompanhamento a qualquer momento, cessando esse tratamento.",
    },
    {
        tipo: "texto",
        texto:
            "A comunicação entre Anfitrião e Conviva ocorre por meio de canais intermediados pela própria Plataforma, nos termos da Seção 1.11 dos Termos Gerais de Uso. Dessa forma, a Empiria não compartilha entre Anfitrião e Conviva dados de contato pessoal e direto, como número de telefone particular, e-mail pessoal ou perfis em redes sociais. As informações eventualmente compartilhadas entre os Usuários limitam-se ao necessário para a realização do Encontro, tais como nome de exibição na Plataforma, informações sobre a participação no Encontro e mensagens trocadas pelo chat interno, sem prejuízo do compartilhamento de dados de pagamento com os agentes financeiros descritos nesta Política.",
    },
    {
        tipo: "item",
        id: "6.1.7.",
        texto:
            "Com Serviços Integrados escolhidos pelo Usuário.",
    },
    {
        tipo: "item",
        id: "6.1.8.",
        texto:
            "Com Parceiros de Negócio, para eventos, promoções e concursos.",
    },
    {
        tipo: "item",
        id: "6.1.9.",
        texto:
            "Com Anunciantes e Provedores de Dados Analíticos, por meio de cookies ou outras tecnologias.",
    },
    {
        tipo: "item",
        id: "6.1.10.",
        texto:
            "Com Autoridades Governamentais, Policiais ou o Poder Judiciário, sempre que necessário para atender ordem judicial ou solicitação de autoridade.",
    },
    {
        tipo: "secao",
        texto:
            "7. INTEGRAÇÕES E TERCEIROS PARCEIROS",
    },
    {
        tipo: "item",
        id: "7.1.",
        texto:
            "Você pode permitir que a nossa Plataforma interaja com serviços de terceiros (como Facebook, Google, Zoom). Serviços de terceiros são operados, controlados e mantidos por Terceiros, sem qualquer relacionamento conosco.",
    },
    {
        tipo: "item",
        id: "7.2.",
        texto:
            "De modo específico, a empresa Empiria, em determinados casos, pode vincular serviços de terceiros à Plataforma por meio de application programming interfaces (APIs). Estes serviços não integram o escopo dos serviços da empresa Empiria.",
    },
    {
        tipo: "secao",
        texto:
            "8. TRANSFERÊNCIAS INTERNACIONAIS",
    },
    {
        tipo: "item",
        id: "8.1.",
        texto:
            "A empresa Empiria pode transferir os seus dados pessoais a países diferentes daquele onde você está localizado. A empresa Empiria adota as medidas exigidas por lei para assegurar a proteção desses dados pessoais, firmando contratos com os receptores de respectivas informações que estabeleçam medidas condizentes com as normas dos locais nos quais os dados pessoais tenham sido inicialmente coletados.",
    },
    {
        tipo: "secao",
        texto:
            "9. DIREITOS COM RELAÇÃO AOS SEUS DADOS PESSOAIS",
    },
    {
        tipo: "item",
        id: "9.1.",
        texto:
            "Direitos: A depender das leis aplicáveis ao tratamento de seus dados pessoais, você pode possuir determinados direitos específicos em relação às suas informações pessoais. Abaixo estão listados os direitos aplicáveis:",
    },
    {
        tipo: "item",
        id: "9.1.1.",
        texto:
            "Confirmação da existência do tratamento.",
    },
    {
        tipo: "item",
        id: "9.1.2.",
        texto:
            "Acesso aos dados.",
    },
    {
        tipo: "item",
        id: "9.1.3.",
        texto:
            "Retificação.",
    },
    {
        tipo: "item",
        id: "9.1.4.",
        texto:
            "Anonimização, bloqueio ou exclusão.",
    },
    {
        tipo: "item",
        id: "9.1.5.",
        texto:
            "Portabilidade, observados o segredo comercial e industrial da empresa Empiria.",
    },
    {
        tipo: "item",
        id: "9.1.6.",
        texto:
            "Informações sobre compartilhamento.",
    },
    {
        tipo: "item",
        id: "9.1.7.",
        texto:
            "Informações sobre a possibilidade de negar seu consentimento.",
    },
    {
        tipo: "item",
        id: "9.1.8.",
        texto:
            "Revogação de consentimento.",
    },
    {
        tipo: "item",
        id: "9.1.9.",
        texto:
            "Oposição ao tratamento, inclusive quanto ao treinamento de sistemas de Inteligência Artificial mencionado no item 2.1.1 desta Política.",
    },
    {
        tipo: "item",
        id: "9.1.10.",
        texto:
            "Reclamação perante a Autoridade Nacional de Proteção de Dados.",
    },
    {
        tipo: "item",
        id: "9.1.11.",
        texto:
            "Exclusão de dados tratados com consentimento.",
    },
    {
        tipo: "item",
        id: "9.1.12.",
        texto:
            "Revisão de decisões automatizadas, nos termos do item 6.1.2.1 desta Política.",
    },
    {
        tipo: "item",
        id: "9.2.",
        texto:
            "Sempre que a empresa Empiria estiver atuando em nome de terceiros, e o Usuário decidir buscar junto à empresa Empiria o atendimento a um de seus direitos, poderemos atender, em certas circunstâncias, a essa solicitação, caso aplicável.",
    },
    {
        tipo: "item",
        id: "9.3.",
        texto:
            "Se você desejar cancelar o envio de newsletters, e-mails, telefonemas ou SMS publicitários, poderá fazê-lo através do link fornecido nas próprias comunicações.",
    },
    {
        tipo: "item",
        id: "9.4.",
        texto:
            "A Empiria se reserva no direito de recusar o atendimento de solicitações que sejam manifestamente infundadas e/ou excessivas.",
    },
    {
        tipo: "item",
        id: "9.5.",
        texto:
            "Todos os direitos acima que forem aplicáveis na sua jurisdição podem ser exercidos por você a qualquer tempo, de modo gratuito, salvo se a cobrança de uma taxa for permitida de acordo com a legislação ou regulamentação vigente.",
    },
    {
        tipo: "item",
        id: "9.6.",
        texto:
            "Para garantir que os direitos estão sendo exercidos por você ou por seu representante legal devidamente constituído, a empresa Empiria poderá solicitar informações ou comprovações necessárias acerca da sua identidade.",
    },
    {
        tipo: "item",
        id: "9.7.",
        texto:
            "Atenderemos às suas solicitações dentro do prazo indicado no item 5.3 desta Política.",
    },
    {
        tipo: "item",
        id: "9.8.",
        texto:
            "Em determinados casos, como quando a sua solicitação for particularmente complexa ou quando recebermos um volume elevado de solicitações ao mesmo tempo, manteremos você sempre informado e atualizado sobre o andamento da sua solicitação.",
    },
    {
        tipo: "secao",
        texto:
            "10. SEGURANÇA",
    },
    {
        tipo: "item",
        id: "10.1.",
        texto:
            "Medidas de Segurança. A empresa Empiria emprega medidas de segurança, técnicas e organizacionais necessárias para proteger os dados pessoais que trata. Para mais informações, acesse a Política de Segurança Cibernética e da Informação.",
    },
    {
        tipo: "item",
        id: "10.1.1.",
        texto:
            "Embora a empresa Empiria implemente essas medidas para minimizar riscos de incidentes de segurança e de acessos indevidos, não é possível garantir a segurança absoluta dos seus dados, especialmente contra ataques perpetrados por pessoas mal-intencionadas.",
    },
    {
        tipo: "item",
        id: "10.2.",
        texto:
            "A segurança dos seus dados também depende da adoção de medidas razoáveis por você no uso de seus dispositivos e softwares.",
    },
    {
        tipo: "secao",
        texto:
            "11. TRATAMENTO DE DADOS PESSOAIS DE MENORES",
    },
    {
        tipo: "item",
        id: "11.1.",
        texto:
            "Dados Pessoais de Menores. A empresa Empiria não coleta nem solicita conscientemente dados pessoais de menores de 13 anos. Se tomarmos conhecimento de que dados pessoais de um menor de 13 anos foram coletados, cancelaremos a conta criada na Plataforma e excluiremos os dados pessoais, apenas mantendo dados pessoais que tenham como objetivo evitar nova tentativa de cadastro.",
    },
    {
        tipo: "texto",
        texto:
            "Para adolescentes entre 13 e 18 anos, o tratamento de dados pessoais depende de consentimento específico e destacado dos pais ou responsáveis legais, nos termos do artigo 14, §1º, da LGPD, sem prejuízo da autorização geral de cadastro prevista nos Termos Gerais de Uso.",
    },
    {
        tipo: "secao",
        texto:
            "12. DÚVIDAS",
    },
    {
        tipo: "texto",
        texto:
            "Para mais informações sobre a Política de Cookies e Privacidade, entre em contato conosco pelas linhas de contato para tirar dúvidas na Plataforma da Empiria, www.empiriapp.com.br, ou diretamente com o Encarregado de Dados pelo e-mail dpo@empiriapp.com.br.",
    },
];

export default cookiesEPrivacidade;
